import Accommodation from '@/models/Accommodation'
import Api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1
    },
    fetchingList: false,
    accommodationDetails: {
      name: '',
      types: [],
      description: '',
      image: null,
      places_address: '',
      website: '',
      phone_number: '',
      google_accommodations_id: null
    },
    accommodationLocation: null
  },

  mutations: {
    setFetchingList(state, status) {
      state.fetchingList = status
    },

    setAccommodationList(state, accommodations) {
      each(accommodations, accommodation => {
        const exist = find(state.list, { id: accommodation.id })
        if (!exist) {
          state.list.push(new Accommodation(accommodation))
        }
      })
    },

    clearAccommodationList(state) {
      state.list = []
    },

    setAccommodationListMeta(state, meta) {
      state.listMeta = meta
    },

    setAccommodationDetails(state, accommodation) {
      if (accommodation instanceof Accommodation) {
        state.accommodationDetails = accommodation
      } else {
        state.accommodationDetails = new Accommodation(accommodation)
      }
    },

    clearAccommodationDetails(state) {
      state.accommodationDetails = {
        name: '',
        types: [],
        description: '',
        image: null,
        places_address: '',
        website: '',
        phone_number: '',
        google_accommodations_id: null
      }
    },

    setAccommodationLocation(state, locations) {
      state.accommodationLocation = locations
    }
  },

  actions: {
    async getAccommodationLocation({ commit }, input) {
      const { data } = await Api.get(`accommodations?input=${input}`)
      commit('setAccommodationLocation', data.data)
    },

    resetAccommodationLocation({ commit }) {
      commit('setAccommodationLocation', null)
    },

    clearAccommodationDetails({ commit }) {
      commit('clearAccommodationDetails')
    },

    async createAccommodation({ commit }, formData) {
      const { data } = await Api.post(`admin/accommodations`, formData, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      commit('setAccommodationDetails', data.data)
    },

    async updateAccommodation({ commit }, formData) {
      const { data } = await Api.post(
        `admin/accommodations/${formData.get('id')}`,
        formData
      )
      commit('setAccommodationDetails', data.data)
    },

    async deleteAccommodation({ commit }, accommodationId) {
      const { data } = await Api.delete(
        `admin/accommodations/${accommodationId}`
      )
      commit('setAccommodationDetails', data.data)
    },

    async getAccommodations({ commit }, params) {
      const query = Accommodation.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      commit('setFetchingList', true)
      const res = await query
        .params({ limit: 20 })
        .get()
        .finally(() => {
          commit('setFetchingList', false)
        })

      commit('setAccommodationList', res.data)
      commit('setAccommodationListMeta', res.meta)
    },

    async getAccommodationDetails({ commit }, id) {
      const { data } = await Api.get(`admin/accommodations/${id}`)
      commit('setAccommodationDetails', data.data)
    },

    async getAllAccommodations({ commit }) {
      commit('setFetchingList', true)
      const { data } = await Api.get(`admin/accommodations?all=true`).finally(
        () => {
          commit('setFetchingList', false)
        }
      )
      commit('setAccommodationList', data.data)
    }
  }
}
